import type { LevelDef } from '../level.ts';

// Schiphol's compass rose, stylised down to four spokes at four angles around
// one field: two polder parallels, an east-west crosser along the top, and a
// diagonal. The finale — every arrival is a choice of spoke.
export const amsterdam: LevelDef = {
  id: 'amsterdam', city: 'amsterdam', country: 'netherlands',
  blurb: 'polder light, four strips at four angles, pick a spoke',
  baseline: 775, scoreMul: 2.5,
  capBase: 4, capDiv: 4, capMax: 7,
  spawnLead: [5, 11], minSpawnGap: 1.9, tempo: 1,
  mix: [['light', 0.18], ['medium', 0.26], ['heavy', 0.24], ['jet', 0.22], ['heli', 0.10]],
  layout: {
    runways: [
      { x1: -0.80, y1: 0.40, x2: -0.78, y2: -0.62 },
      { x1: -0.30, y1: 0.55, x2: -0.26, y2: -0.45 },
      { x1: 0.00, y1: -0.74, x2: 0.86, y2: -0.72, w: 24 },
      { x1: 0.10, y1: 0.66, x2: 0.80, y2: 0.10 },
    ],
    pads: [{ x: 0.20, y: 0.86, frac: true }],
  },
  palette: { bg: '#f7f7f0', field: '#e6ead6', deep: '#dae0c8', water: '#c9dbdc' },
  decor: ['windmill', 'canals'],
  arrivalSides: [1, 1, 1.2, 1.2],
  // c4 major pentatonic: glassy, airy, wind
  music: { root: 60, mode: 'major pentatonic', bpm: 68, wind: 0.9, verb: 0.4, bright: 3800 },
};
